import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const BranchRoutes = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/branch-routes'),
      component: SettingsContent,
      props: {
        headerTitle: 'BRANCH_ROUTES.HEADER',
        icon: 'arrow-swap',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'branch_routes_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'branch_routes_list',
          component: BranchRoutes,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
